import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import { DEFAULT_ITEMS_PER_PAGE } from 'utils/pagination';
import filterObject from 'utils/filterObject';
var BASE_USERS_KEY = 'users';
function normalizeUsersQueryKey(query) {
  return filterObject({
    limit: query.limit !== undefined ? Number(query.limit) : undefined,
    search: query.search,
    offset: query.offset !== undefined ? Number(query.offset) : undefined,
    ids: query.ids === undefined ? undefined : Array.isArray(query.ids) ? query.ids.map(function (id) {
      return Number(id);
    }) : Number(query.ids),
    teamId: query.teamId !== undefined ? Number(query.teamId) : undefined,
    assetId: query.assetId !== undefined ? Number(query.assetId) : undefined,
    eventSessionId: query.eventSessionId !== undefined ? Number(query.eventSessionId) : undefined,
    includeDeletedUsers: query.includeDeletedUsers,
    filterForAdminRole: query.filterForAdminRole
  });
}
var usersKeys = {
  users: [BASE_USERS_KEY],
  usersQuery: function usersQuery(query) {
    return [BASE_USERS_KEY, 'query', normalizeUsersQueryKey(query)];
  },
  singleUser: function singleUser(id) {
    return [BASE_USERS_KEY, 'single', Number(id)];
  },
  singleUserDetails: function singleUserDetails(userId, teamId) {
    return [BASE_USERS_KEY, 'single', Number(userId), 'details', Number(teamId)];
  },
  singleUserAnalysis: function singleUserAnalysis(userId, weekCommencingDate) {
    return [BASE_USERS_KEY, 'single', Number(userId), 'analysis', weekCommencingDate || 'latest'];
  },
  singleUserMeetingAnalysis: function singleUserMeetingAnalysis(meetingId, userId) {
    return [BASE_USERS_KEY, 'single', Number(userId), 'analysis', 'meeting', Number(meetingId)];
  },
  singleUserSkillAnalysis: function singleUserSkillAnalysis(skillId, userId, weekCommencingDate) {
    return [BASE_USERS_KEY, 'single', Number(userId), 'analysis', 'skill', Number(skillId), weekCommencingDate || 'latest'];
  },
  singleUserAnalysisWeeks: function singleUserAnalysisWeeks(id) {
    return [BASE_USERS_KEY, 'single', Number(id), 'analysis', 'weeks'];
  },
  singleUserAnalysisSkills: function singleUserAnalysisSkills(_ref) {
    var skillId = _ref.skillId,
      userId = _ref.userId,
      weekCommencingDate = _ref.weekCommencingDate,
      _ref$limit = _ref.limit,
      limit = _ref$limit === void 0 ? DEFAULT_ITEMS_PER_PAGE : _ref$limit,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 0 : _ref$offset;
    return [BASE_USERS_KEY, 'single', Number(skillId), Number(userId), 'analysis', 'skills', weekCommencingDate || 'latest', Number(limit), Number(offset)];
  },
  usersSearch: function usersSearch(query) {
    return [BASE_USERS_KEY, query];
  },
  userLogs: function userLogs(_ref2) {
    var _ref2$search = _ref2.search,
      search = _ref2$search === void 0 ? null : _ref2$search,
      _ref2$userId = _ref2.userId,
      userId = _ref2$userId === void 0 ? null : _ref2$userId,
      limit = _ref2.limit;
    return [BASE_USERS_KEY, 'logs', search, userId, Number(limit)];
  },
  paginatedUsers: function paginatedUsers(search, page, limit) {
    return [BASE_USERS_KEY, 'paginated', search, page, limit];
  },
  singleUserAnalysisSkillsContent: function singleUserAnalysisSkillsContent(_ref3) {
    var skillId = _ref3.skillId,
      userId = _ref3.userId,
      limit = _ref3.limit,
      offset = _ref3.offset;
    return [BASE_USERS_KEY, 'single', Number(skillId), Number(userId), 'analysis', 'skills', 'content', Number(limit), Number(offset)];
  },
  helixAccess: function helixAccess(id) {
    return [BASE_USERS_KEY, 'single', id || (id = 'me'), 'helixAccess'];
  }
};
export default usersKeys;